import {
  Vector3,
  Raycaster,
  Vector2,
  CylinderGeometry,
  MeshBasicMaterial,
  Mesh,
  Sprite,
  TextureLoader, BoxGeometry,
} from "three";
import TWEEN from "@tweenjs/tween.js";

import { config } from "./../config";

import SpriteTexture from "../../../static/img/click.png";
import footprints from "../../../static/img/footprints.png";
import {OrbitControls} from "three/examples/jsm/controls/OrbitControls";
const painting = require.context(
    "../../../static/img/paintings",
    true,
    /\.png$/
);

const YTPlayer = require("yt-player");

let fwdValue = 0;
let bkdValue = 0;
let rgtValue = 0;
let lftValue = 0;

let tempVector = new Vector3();
let upVector = new Vector3(0, 1, 0);


export default class PointerLock {
  constructor(viewer) {
    this.viewer = viewer;
    this.moveForward = false;
    this.moveBackward = false;
    this.moveLeft = false;
    this.moveRight = false;
    this.velocity = new Vector3();
    this.prevTime = performance.now();
    this.direction = new Vector3();
    this.previousStep = new Vector3(0, 10, 0);
    this.mouse = new Vector2(0, 0);
    this.frontRay = new Raycaster();
    this.point2 = {};
    this.point = {};
    this.switch = false;
    this.spriteMap = new TextureLoader().load(SpriteTexture);
    this.footprint = new TextureLoader().load(footprints);
    this.paintings = painting.keys().reduce((images, key) => {
      images[key] = painting(key);
      return images;
    }, {});
    this.firstLog = true;
    this.player = new YTPlayer("#ytplayer");
    this.descImage = document.getElementById('descImage');
    this.title = document.getElementById('title');
    this.descD = document.getElementById('descD');
    this.mouse = new Vector2(0,0);
    this.init();
  }

  init() {
    let geometry = new BoxGeometry(0.4, 0.00001, 0.4);
    let material = new MeshBasicMaterial({
      map: this.footprint,
      color: 0xffffff,
      transparent: true,
      opacity: 1,
    });
    this.circle = new Mesh(geometry, material);
    this.viewer.scene.add(this.circle);

    let geometry2 = new CylinderGeometry(0.3, 0.3, 0.001, 32);
    let material2 = new MeshBasicMaterial({
      color: 0xffffff,
      // transparent: true,
      opacity: 1,
    });
    this.circle2 = new Mesh(geometry2, material2);
    this.viewer.scene.add(this.circle2);

    this.controls = new OrbitControls(
        this.viewer.camera,
        this.viewer.renderer.domElement
    );

    this.controls.listenToKeyEvents(window);
    if (this.firstLog) {
      this.controls.maxAzimuthAngle = 1.5970000000000023;
      this.controls.minAzimuthAngle = 1.5850000000000025;
    }
    this.controls.target = new Vector3(0, 1.7, 0);
    this.controls.enableZoom = true;
    window.controls = this.controls;
    this.controls.update();
    document.getElementById("painting__close").addEventListener(
        "click",
        () => {
          // this.controls.lock();
          this.player.stop();
          document.getElementById("popup-painting").classList.remove("active");
          document.getElementById("mainOptWrap").classList.remove("none");
          this.viewer.image.removeAttribute("style")
        },
        false
    );

    var onKeyDown = (event) => {
      switch (event.keyCode) {
        case 38: // up
        case 87: // w
          this.moveForward = true;
          break;

        case 37: // left
        case 65: // a
          this.moveLeft = true;
          break;

        case 40: // down
        case 83: // s
          this.moveBackward = true;
          break;

        case 39: // right
        case 68: // d
          this.moveRight = true;
          break;
      }
    };

    var onKeyUp = (event) => {
      switch (event.keyCode) {
        case 38: // up
        case 87: // w
          this.moveForward = false;
          break;

        case 37: // left
        case 65: // a
          this.moveLeft = false;
          break;

        case 40: // down
        case 83: // s
          this.moveBackward = false;
          break;

        case 39: // right
        case 68: // d
          this.moveRight = false;
          break;
      }
    };

    document.addEventListener("keydown", onKeyDown, false);
    document.addEventListener("keyup", onKeyUp, false);

    this.raycaster = new Raycaster(
        new Vector3(),
        new Vector3(0, -1, 0),
        0,
        100
    );
    this.viewer.container.addEventListener("click", this.onClick.bind(this));
    this.controls.addEventListener('start', () => {
      this.firstLog = false;
      this.controls.maxAzimuthAngle = Infinity;
      this.controls.minAzimuthAngle = Infinity;
      this.circle.visible = false
      this.circle2.visible = false
      this.startCameraPoz = this.controls.object.position.clone();
      this.controlsChanges = false;
    })
    this.controls.addEventListener('end', () => {
      this.circle.visible = true;
      this.circle2.visible = true;
      if (this.startCameraPoz.x !== this.controls.object.position.x || this.startCameraPoz.z !== this.controls.object.position.z) {
        this.controlsChanges = true;
      }
    })
    document.addEventListener( 'mousemove', this.onMouseMove.bind(this) );
  }

  onTouch2(direction) {
    this.raycaster.ray.origin.copy(this.controls.position0);
    let intersections = this.raycaster.intersectObjects(
        this.viewer.meshOnScene
    );
    this.frontRay.ray.set(camera.position, direction);
    const intersects = this.frontRay.intersectObjects(this.viewer.meshOnScene);
    if (intersections[0].object.name === "floor_nav" && intersects[0].distance >= 1) {
      return true
    } else {
      return false;
    }
  }
  onMouseMove( event ) {
    event.preventDefault();
    this.mouse.x = ( event.clientX / window.innerWidth ) * 2 - 1;
    this.mouse.y = - ( event.clientY / window.innerHeight ) * 2 + 1;
  }
  motion() {
    this.portal();

    const angle = this.controls.getAzimuthalAngle();

    if (this.moveForward) {
      tempVector.set(0, 0, -1).applyAxisAngle(upVector, angle);
      if (this.onTouch2(tempVector)) {
        camera.position.addScaledVector(tempVector, 0.05);
        this.controls.target.addScaledVector(tempVector, 0.05);
      }
    }
    if (this.moveBackward) {
      tempVector.set(0, 0, 1).applyAxisAngle(upVector, angle);
      if (this.onTouch2(tempVector)) {
        camera.position.addScaledVector(tempVector, 0.04);
        this.controls.target.addScaledVector(tempVector, 0.04);
      }
    }
    if (this.moveLeft) {
      tempVector.set(-1, 0, 0).applyAxisAngle(upVector, angle);
      if (this.onTouch2(tempVector)) {
        camera.position.addScaledVector(tempVector, 0.05);
        this.controls.target.addScaledVector(tempVector, 0.05);
      }
    }
    if (this.moveRight) {
      tempVector.set(1, 0, 0).applyAxisAngle(upVector, angle);
      if (this.onTouch2(tempVector)) {
        camera.position.addScaledVector(tempVector, 0.05);
        this.controls.target.addScaledVector(tempVector, 0.05);
      }
    }
  }
  func(obj, cam, objRotation) {

  }

  portal() {
    if (this.controls) {
      this.frontRay.setFromCamera(this.mouse, this.viewer.camera);
      this.intersects = this.frontRay.intersectObjects(this.viewer.meshOnScene);
      if (this.intersects.length > 0 && this.intersects[0].object.name === "floor_nav") {
        this.circle.material.opacity = 1;
        this.circle2.material.opacity = 1;
        this.circle.position.y -= 0.001
        this.circle2.position.copy(this.intersects[0].point);
        this.circle2.position.y -= 0.001
        this.circle.position.copy(this.intersects[0].point);
        const camPoz = this.viewer.camera.position.clone();
        camPoz.y = this.circle.position.y;
        this.circle.lookAt(camPoz);
      }
      if (this.intersects.length > 0 && config[this.intersects[0].object.name]) {
        document.body.style.cursor = 'pointer';
      } else {
        document.body.style.cursor = 'default';
      }
      if (this.intersects.length > 0 && config[this.intersects[0].object.name]) {
        if (!this.point[this.intersects[0].object.name]) {
          const sprite = new Sprite();
          this.viewer.scene.add(sprite);
          // console.log(sprite)
          // sprite.name = this.intersects[0].object.name;
          if (this.curent) this.curent.visible = false;
          this.curent = sprite;
          this.curent.visible = false;
          this.point[this.intersects[0].object.name] = sprite;
        } else {
          if (this.curent && this.curent.name !== this.point[this.intersects[0].object.name].name)
          this.curent = this.point[this.intersects[0].object.name];
        }
        this.painting = this.intersects[0];
      } else {
        if (this.painting && this.point[this.painting.object.name]) {
          this.point[this.painting.object.name].visible = false;
        }
        document.getElementById("select-point").classList.add("none");
        this.painting = null;
      }
    }
  }

  onClick() {
    this.viewer.tutorialSwitch = false;
    if (this.disableFly || this.controlsChanges) return;
    if (
        this.intersects.length > 0 &&
        this.intersects[0].object.name === "floor_nav"
    ) {
      const cameraPozY = this.viewer.camera.position.y;
      let coords = {
        x: this.controls.object.position.x,
        z: this.controls.object.position.z,
      };
      const distance = this.controls.target.distanceTo(this.viewer.camera.position);
      const diff = this.controls.target.clone().add(this.controls.object.position.clone().negate());

      new TWEEN.Tween(coords)
          .to(
              { x: this.intersects[0].point.x, z: this.intersects[0].point.z },
              1000
          )
          .easing(TWEEN.Easing.Linear.None)
          .onStart(() => {
            this.circle.visible = false;
            this.circle2.visible = false;
            this.disableFly = true;
            this.controls.enableRotate = false;
          })
          .onUpdate(() => {
            this.controls.target.x = coords.x;
            this.controls.target.z = coords.z;
            this.controls.object.position.copy(this.controls.target.clone().add(diff.clone().negate()));
            this.controls.update();
          })
          .onComplete(() => {
            this.circle.visible = true;
            this.circle2.visible = true;
            this.controls.enableRotate = true;
            this.disableFly = false;
          })
          .start();
    }

    if (this.painting) {
      if (document.getElementById("select-language").value === "English") {
        this.data = config[this.painting.object.name];
      }
      this.viewer.tutorial.classList.add('none');
      this.painting = document.getElementById("popup-painting");
      this.optionWrap = document.getElementById('mainOptWrap');
      this.painting.classList.add("active");
      if (this.painting.classList.contains('active')) {
        this.optionWrap.classList.add('none');
      }

      let link = [];
      let temp0 = "";
      this.data.link.forEach((item, index) => {
        link.push(item);
      });
      this.data.description.forEach((item, index) => {
        if (index === 0) {
          temp0 += "<div class='descDiv'>" + item + "</div>";
        }
        // else {
        //   temp0 += "<a target='_blank' class='descDivLink'>" + item + "</a>";
        // }
      });
      this.data.pointerDesc.forEach((item, index) => {
        temp0 += "<a target='_blank' class='descDivLink'>" + item + "</a>";
      })

      document.getElementById("painting__desc").innerHTML = temp0;
      const elements = document.querySelectorAll(".descDivLink");
      elements.forEach((i, index) => {
        i.href = link[index];
      })
      // console.log(this.paintings);
      // console.log(this.data.smallPainting);
      // console.log(this.paintings[this.data.smallPainting]);
      // console.log(this.paintings[this.data.smallPainting].default);

      document.getElementById("painting__img").style.backgroundImage =
          "url(" + this.paintings[this.data.painting] + ")";
      document.getElementById("painting__mobile").src =
          this.paintings[this.data.smallPainting].default;

      if (this.data.video) {
        document.getElementById("painting__controls-video").style.display =
            "block";
        this.player.load(this.data.video);
      }
    }
  }
}

